
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DropsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const DropsDialog = ({ open, onOpenChange }: DropsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl mx-auto bg-gradient-to-br from-purple-900/95 to-black/95 border-purple-500/20 backdrop-blur-lg max-h-[90vh] overflow-hidden p-0">
        <div className="flex flex-col md:flex-row h-full min-h-[500px]">
          {/* Left Side - Content */}
          <div className="flex-1 p-6 flex flex-col justify-center space-y-6">
            <DialogHeader className="text-center md:text-left space-y-3">
              <DialogTitle className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-purple-300 bg-clip-text text-transparent">
                🎯 Coming Soon: DROPS
              </DialogTitle>
            </DialogHeader>
            
            <div className="space-y-4">
              <p className="text-gray-200 text-base md:text-lg leading-relaxed">
                FOMO is reinventing advertisement by offering branded digital collectibles hidden throughout your feed.
              </p>
              <p className="text-white text-lg md:text-xl leading-relaxed font-bold bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">
                Find them. Collect them. Earn real money. Instantly.
              </p>
              <p className="text-xs md:text-sm text-gray-400">
                This feature is currently in development
              </p>
            </div>
          </div>
          
          {/* Right Side - Full Image */}
          <div className="flex-1 relative overflow-hidden">
            <img 
              src="https://guwcqpytunuquoirejsc.supabase.co/storage/v1/object/public/fomo-assets/dropsad.png"
              alt="Collectible digital item"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-l from-transparent via-purple-600/10 to-purple-600/20" />
          </div>
        </div>
        
        {/* Bottom Disclaimer */}
        <div className="absolute bottom-0 left-0 right-0 bg-black/80 backdrop-blur-sm border-t border-purple-500/20 p-3">
          <p className="text-center text-xs text-gray-400">
            Brands, if you're interested in our unique advertisement model please reach out to{' '}
            <a 
              href="mailto:axl@dontfomo.app" 
              className="text-purple-400 hover:text-purple-300 transition-colors underline"
            >
              axl@dontfomo.app
            </a>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DropsDialog;
